// extracted by mini-css-extract-plugin
module.exports = {"Match":"HighlightMatch_Match__bBsTl"};